<div class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ item.userData?.fullName }}</span>
    <button class="icon-button icon-close" (click)="goToMainView()"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">{{ "users.main.information" | translate }}</div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-2 card-cell label-span">
              <label>{{ "users.item.fullName" | translate }}</label>
              <span>{{ item.userData?.fullName }}</span>
            </div>

            <div class="flex-2 card-cell label-span">
              <label>{{ "users.item.eMail" | translate }}</label>
              <span>{{ item.userData?.eMail }}</span>
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-2 card-cell label-span">
              <label>{{ "users.item.gid" | translate }}</label>
              <span>{{ item.id }}</span>
            </div>
            <div class="flex-2 card-cell label-span">
              <label>Gender</label>
              <span>{{ item.userData?.gender }}</span>
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell label-span">
              <label>{{ "users.item.department" | translate }}</label>
              <span>{{ item.userData?.department }}</span>
            </div>
            <div class="flex-1 card-cell label-span">
              <label>{{ "users.item.departmentText" | translate }}</label>
              <span>{{ item.userData?.departmentText }}</span>
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-2 card-cell label-span">
              <label>{{ "users.item.roleTitle" | translate }}</label>
              <span>{{ "users.item.role." + item.userRole | translate }}</span>
            </div>
            <div class="flex-2 card-cell"></div>
          </div>
        </div>
      </div>
      <!--			<div class="information-container">
							<div class="statistics-title statistics-title&#45;&#45;full">{{'users.main.certificate' | translate}}</div>
							<div class="information-content flex-row">
								<div class="flex-row">
									<div class="flex-1 card-cell">
										<span class="information-text">
											{{'users.main.certificateInformation' | translate}}
											<ng-container *ngIf="item.certificateExpiration">
												{{'users.main.certificateExpiration' | translate: {date: (item.certificateExpiration | date: 'MMM d y h:mm')} }}
											</ng-container>
										</span>
									</div>
								</div>
							</div>
						</div>-->
    </div>
  </div>
</div>
